/**
 * Help center articles linked from the app.
 *
 * Every url lives here so a renamed or moved article is one line to change instead of a grep
 * across the call sites. Only the numeric id is stored: Freshdesk resolves
 * /articles/11000136191 exactly like the slugged /articles/11000136191-some-title, and the
 * slugs went stale as articles got retitled.
 */
const SOLUTIONS_BASE = 'https://support.langify-app.com/support/solutions';

export const SOLUTIONS_ARTICLES = {
  manageLanguages: '11000081195',
  translatingContent: '11000082047',
  assignLanguagesToDomains: '11000119897',
  publishingLangify: '11000124801',
  switcherConfigurator: '11000084362',
  countryCurrency: '11000084371',
  productTranslations: '11000082051',
  productTypes: '11000137414',
  notificationTranslations: '11000082050',
  customContentTranslations: '11000082059',
  homepageTranslations: '11000135802',
  metafieldTranslations: '11000133763',
  metaobjectsIdentify: '11000131879',
  machineTranslationSettings: '11000136291',
  machineTranslations: '11000100274',
  bulkTranslation: '1000075598',
  customContentPerformance: '11000136191',
  customContentPlaceholderMatching: '11000133898',
  staticSectionCode: '11000124803',
  glossary: '11000134567',
  planFeatures: '11000128806',
  collectionFilters: '11000136165',
  exportTranslations: '11000082134',
  importTranslations: '11000101148',
};

// the documentation root - a folder, not an article, so it does not go through the helper
export const SOLUTIONS_ROOT_URL = `${SOLUTIONS_BASE}/11000004136`;

// a key that no longer exists lands on the documentation root rather than on a 404
export const solutionsArticleUrl = (key) => SOLUTIONS_ARTICLES[key]
  ? `${SOLUTIONS_BASE}/articles/${SOLUTIONS_ARTICLES[key]}`
  : SOLUTIONS_ROOT_URL;
